<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Update</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Update <b>{{data.displayName}}</b></div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form modal-p2p-padding ">
    <div class="row justify-content-center">
        <div class="col-12">
            <div class="md-form">
                <input mdbInput type="text" class="form-control validate mb-0" maxlength="128"
                    [(ngModel)]="displayNameInputValue" 
                    (ngModelChange)="isEditActive = true"
                    (focus)="onInputFocus()" 
                    (keyup.enter)="update()"
                >
                <label mdbLabel [ngClass]="{'active': isDisplayNameLabelActive}" class="inputLabel">Display Name</label>
                @if(showDisplayNameError) {
                    <span class="form-error m-0">Incorrect Display Name</span>
                }
            </div>
        </div>

        <div class="col-12">
            <div class="md-form">
                <input mdbInput type="text" class="form-control validate mb-0" maxlength="128"
                    [(ngModel)]="createdByNameInputValue" 
                    (ngModelChange)="isEditActive = true"
                    (focus)="onInputFocus()" 
                    (keyup.enter)="update()"
                />
                <label mdbLabel [ngClass]="{'active': isCreatedByNameLabelActive}" class="inputLabel">Created By Name</label>
                @if(showCreatedByNameError) {
                    <span class="form-error m-0">Incorrect Created By Name</span>
                }
            </div>
        </div>

        <div class="col-12">
            <div class="md-form">
                <input
                    id="p2pGoal"
                    currencyMask
                    [(ngModel)]="goalInputValue" 
                    (ngModelChange)="isEditActive = true"
                    (focus)="onInputFocus()"
                    (keyup.enter)="update()"
                    required
                    type="text"
                    class="form-control mb-0"
                >
                <label mdbLabel data-error="" class="inputLabel active" for="p2pGoal">Goal</label>
                @if(showGoalError) {
                    <span class="form-error m-0">Incorrect Goal</span>
                }
            </div>
        </div>
    </div>
</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="close()">Cancel</a>
    <a [ngClass]="{'disabled': !isEditActive}" class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="update()">Update</a>
</div>